const noCollection = [
{
"_id": 0,	
"id": 0,
"userId": 0,
"name": "No Collection Selected",
"type": "",
"recipes": [],
"recommendTo": []
}
];

class CollectionApi {

	//------------------COLLECTION FUNCTIONS------------------
	static loadCollection(collection) {
		if (collection.length == 0) { //no libraries
			return new Promise((resolve, reject) => {
				resolve(Object.assign([], noCollection));
			});
		} else if (collection[0]._id == 0) { //no libraries
			return new Promise((resolve, reject) => {
				resolve(Object.assign([], noCollection));
			});
		}	
	}
}

export default CollectionApi;



/** WEBPACK FOOTER **
 ** ./src/api/mockCollectionApi.js
 **/